import { ReduxStore } from 'store/types';

function updateNoteIsLoading(state: ReduxStore): boolean {
  return state.intervention.updateNote.config.isLoading;
}

export default updateNoteIsLoading;
